module.exports = __webpack_public_path__ + "img/camera-sample.e2c95242.png";